module.exports = __webpack_public_path__ + "img/genesis.0aa8be6e.png";